import { render, staticRenderFns } from "./MobileScreenlet.vue?vue&type=template&id=7ca071d4&scoped=true"
import script from "./MobileScreenlet.vue?vue&type=script&lang=js"
export * from "./MobileScreenlet.vue?vue&type=script&lang=js"
import style0 from "./MobileScreenlet.vue?vue&type=style&index=0&id=7ca071d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca071d4",
  null
  
)

export default component.exports